window.jqueryValidators={
    messages : (lang) => {
        //translation should not be here
        if (lang != 'en') {
            jQuery.extend(jQuery.validator.messages, {
                required: "Este campo &eacute; requerido.",
                remote: "Por favor, corrija este campo.",
                email: "Por favor, forne&ccedil;a um endere&ccedil;o eletr&ocirc;nico v&aacute;lido.",
                url: "Por favor, forne&ccedil;a uma URL v&aacute;lida.",
                date: "Por favor, forne&ccedil;a uma data v&aacute;lida.",
                dateISO: "Por favor, forne&ccedil;a uma data v&aacute;lida (ISO).",
                number: "Por favor, forne&ccedil;a um n&uacute;mero v&aacute;lido.",
                digits: "Por favor, forne&ccedil;a somente d&iacute;gitos.",
                creditcard: "Por favor, forne&ccedil;a um cart&atilde;o de cr&eacute;dito v&aacute;lido.",
                equalTo: "Por favor, forne&ccedil;a o mesmo valor novamente.",
                accept: "Por favor, forne&ccedil;a um valor com uma extens&atilde;o v&aacute;lida.",
                maxlength: jQuery.validator.format("Por favor, forne&ccedil;a n&atilde;o mais que {0} caracteres."),
                minlength: jQuery.validator.format("Por favor, forne&ccedil;a ao menos {0} caracteres."),
                rangelength: jQuery.validator.format("Por favor, forne&ccedil;a um valor entre {0} e {1} caracteres de comprimento."),
                range: jQuery.validator.format("Por favor, forne&ccedil;a um valor entre {0} e {1}."),
                max: jQuery.validator.format("Por favor, forne&ccedil;a um valor menor ou igual a {0}."),
                min: jQuery.validator.format("Por favor, forne&ccedil;a um valor maior ou igual a {0}."),
                dateBR : "Informe uma data válida",
                cep: "Informe um CEP válido.",
                cpf: "Informe um CPF válido",
                telefone: "Informe um telefone válido",
                celular: "Informe um celular válido"
            });
        } else {
            jQuery.extend(jQuery.validator.messages, {
                required: "This is a required field",
                remote: "Please review this information.",
                email: "invalid email adress.",
                url: "invalid URL.",
                date: "invalid date.",
                dateISO: "invalid date (ISO).",
                number: "invalid number.",
                dateBR : "Invalide date, use format DD/MM/YYYY",
                digits: "Only digits, please.",
                creditcard: "Invalid credit card.",
                equalTo: "Values not matching.",
                accept: "Invalid file extension.",
                maxlength: jQuery.validator.format("Max of {0} characters."),
                minlength: jQuery.validator.format("Needs at least {0} characters."),
                rangelength: jQuery.validator.format("Lenght must be between {0} and {1} characters."),
                range: jQuery.validator.format("Value must be between {0} e {1}."),
                max: jQuery.validator.format("Value must be less or equal to {0}."),
                min: jQuery.validator.format("Value must be greater or equal to {0}."),
                cep: "Inform a valid CEP/ZIP Code",
                cpf: "Invalid CPF",
                telefone: "Invalid Phone Number",
                celular: "Invalid Mobile Phone Number"
            });
        }
    },
    date_br : () => {
        jQuery.validator.addMethod("dateBR", function (value, element) {
            //contando chars
            if (value.length != 10) return (this.optional(element) || false);
            // verificando data
            var data = value;
            var dia = data.substr(0, 2);
            var barra1 = data.substr(2, 1);
            var mes = data.substr(3, 2);
            var barra2 = data.substr(5, 1);
            var ano = data.substr(6, 4);
            if (data.length != 10 || barra1 != "/" || barra2 != "/" || isNaN(dia) || isNaN(mes) || isNaN(ano) || dia > 31 || mes > 12) return (this.optional(element) || false);
            if ((mes == 4 || mes == 6 || mes == 9 || mes == 11) && dia == 31) return (this.optional(element) || false);
            if (mes == 2 && (dia > 29 || (dia == 29 && ano % 4 != 0))) return (this.optional(element) || false);
            if (ano < 1900) return (this.optional(element) || false);
            return (this.optional(element) || true);
        });  // Mensag
    },
    cep : () => {
        jQuery.validator.addMethod("cep", function(e,t) {
            return this.optional(t)||/^\d{5}-\d{3}?$/.test(e)
        });
    },
    cpf : () => {
        jQuery.validator.addMethod("cpf", function(value, element) {
            value = jQuery.trim(value);

            value = value.replace('.','');
            value = value.replace('.','');
            var cpf = value.replace('-','');
            while(cpf.length < 11) cpf = "0"+ cpf;
            var expReg = /^0+$|^1+$|^2+$|^3+$|^4+$|^5+$|^6+$|^7+$|^8+$|^9+$/;
            var a = [];
            var b = new Number;
            var c = 11;
            var i = 0;
            for (i=0; i<11; i++){
                a[i] = cpf.charAt(i);
                if (i < 9) b += (a[i] * --c);
            }
            var x = 0;
            if ((x = b % 11) < 2) { a[9] = 0 } else { a[9] = 11-x }
            b = 0;
            c = 11;
            var y = 0;
            for (y=0; y<10; y++) b += (a[y] * c--);
            if ((x = b % 11) < 2) { a[10] = 0; } else { a[10] = 11-x; }

            var retorno = true;
            if ((cpf.charAt(9) != a[9]) || (cpf.charAt(10) != a[10]) || cpf.match(expReg)) retorno = false;

            return this.optional(element) || retorno;

        });
    },
    cnpj : () => {
        jQuery.validator.addMethod('cnpj',function(value, element){
//            value =  value.split('.').join('');
//            value =  value.split('/').join('');
//            value =  value.split('-').join('');

            if (value.length != 18) return this.optional(element) || false;

            var soma1 = (value[0] * 5) +
                (value[1] * 4) +
                (value[3] * 3) +
                (value[4] * 2) +
                (value[5] * 9) +
                (value[7] * 8) +
                (value[8] * 7) +
                (value[9] * 6) +
                (value[11] * 5) +
                (value[12] * 4) +
                (value[13] * 3) +
                (value[14] * 2);

            var resto = soma1 % 11;
            var digito1 = resto < 2 ? 0 : 11 - resto;

            var soma2 = (value[0] * 6) +
                (value[1] * 5) +
                (value[3] * 4) +
                (value[4] * 3) +
                (value[5] * 2) +
                (value[7] * 9) +
                (value[8] * 8) +
                (value[9] * 7) +
                (value[11] * 6) +
                (value[12] * 5) +
                (value[13] * 4) +
                (value[14] * 3) +
                (value[16] * 2);

            resto = soma2 % 11;
            var digito2 = resto < 2 ? 0 : 11 - resto;

            return this.optional(element) || ((value[16] == digito1) && (value[17] == digito2));
        });
    },
    goalThreshold: () => {

        jQuery.validator.addMethod('goalThreshold',function(value, element, param){

            let sValue = parseInt(value.replace(/\./g, ''));

            if(!value || sValue === 0){return true}


            let paramStr = $(param[1]).val();
            let eValue = parseInt(paramStr.replace(/\./g, ''));
            let tabIndex = $(element).attr('id').replace(/\D/g,'');


            if ( eValue > sValue) {
                $(`#tabs a[href="#meta${tabIndex}"]`).tab('show');
            }


            return sValue > eValue;

        }, 'ATENÇÃO! Esse valor não pode ser menor do que a {0}.\n' +
            '\n' +
            '<br>Some o valor da meta anterior ao valor adicional que você planeja arrecadar.');

    },
    goalMinimunAmount: () => {
        jQuery.validator.addMethod('goalMinimunAmount',function(value, element, param){

            let sValue = parseInt(value.replace(/\./g, ''));
            let eValue = 500;

            if ( eValue > sValue) {
                $('#tabs a[href="#meta1"]').tab('show');
            }

            return sValue > eValue;

        },'O valor desta meta deve maior que 500,00');

    },
    phone : () => {
        jQuery.validator.addMethod('phone',function(value, element){
            return this.optional(element) || /^(\+?\d{1,3}? ?)?(\(0?\d{2}\) ?)?9?\d{4}[-. ]?\d{4}$/.test(value);
        });
        jQuery.validator.addMethod('telefone', function (value, element) {
            value = value.replace("(", "");
            value = value.replace(")", "");
            value = value.replace("-", "");
            value = value.replace(" ", "").trim();
            if (value == '0000000000') {
                return (this.optional(element) || false);
            } else if (value == '00000000000') {
                return (this.optional(element) || false);
            }
            if (["00", "01", "02", "03", , "04", , "05", , "06", , "07", , "08", "09", "10"].indexOf(value.substring(0, 2)) != -1) {
                return (this.optional(element) || false);
            }
            if (value.length < 10 || value.length > 11) {
                return (this.optional(element) || false);
            }
            if (["1", "2", "3", "4","5"].indexOf(value.substring(2, 3)) == -1) {
                return (this.optional(element) || false);
            }
            return (this.optional(element) || true);
        }, 'Informe um telefone válido');
    },
    phone_br : () => {
        jQuery.validator.addMethod('telefone_brasileiro', function (value, element) {
            value = value.replace("(","");
            value = value.replace(")", "");
            value = value.replace("-", "");
            value = value.replace(" ", "").trim();
            if (value == '0000000000') {
                return (this.optional(element) || false);
            } else if (value == '00000000000') {
                return (this.optional(element) || false);
            }
            if (["00", "01", "02", "03", , "04", , "05", , "06", , "07", , "08", "09", "10"].indexOf(value.substring(0, 2)) != -1) {
                return (this.optional(element) || false);
            }
            if (value.length < 10 || value.length > 11) {
                return (this.optional(element) || false);
            }
            if (["1", "2", "3", "4","5", "6", "7", "8", "9"].indexOf(value.substring(2, 3)) == -1) {
                return (this.optional(element) || false);
            }
            return (this.optional(element) || true);
        });
    },
    cellphone : () => {
        jQuery.validator.addMethod('celular', function (value, element) {
            value = value.replace("(", "");
            value = value.replace(")", "");
            value = value.replace("-", "");
            value = value.replace(" ", "").trim();
            if (value == '0000000000') {
                return (this.optional(element) || false);
            } else if (value == '00000000000') {
                return (this.optional(element) || false);
            }
            if (["00", "01", "02", "03", , "04", , "05", , "06", , "07", , "08", "09", "10"].indexOf(value.substring(0, 2)) != -1) {
                return (this.optional(element) || false);
            }
            if (value.length < 10 || value.length > 11) {
                return (this.optional(element) || false);
            }
            if (["6", "7", "8", "9"].indexOf(value.substring(2, 3)) == -1) {
                return (this.optional(element) || false);
            }
            return (this.optional(element) || true);
        });
    },
    load : () => {
        jqueryValidators.messages($(".langHelper").val());
        jqueryValidators.date_br();
        jqueryValidators.cep();
        jqueryValidators.cpf();
        jqueryValidators.phone();
        jqueryValidators.phone_br();
        jqueryValidators.cellphone();
        jqueryValidators.goalThreshold();
        jqueryValidators.goalMinimunAmount();
    }
};
jqueryValidators.load();